<script setup lang="ts">
import GButton from '@/components/common/GButton.vue';
import GInputDynamic from '@/components/common/input/GInputDynamic.vue';
import { Toast } from '@/utils/toast';
import { onBeforeMount } from 'vue';
import type { InputField } from '@/interfaces/common/input_fields';
import { createFormControl, type FormControl } from '@/utils/forms';


const props = withDefaults(defineProps<{
    fields: InputField[],
    disabled?: boolean
}>(), ({
}));

const controls: FormControl[] = [];

onBeforeMount(() => {
    props.fields.forEach(f => {
        controls.push(createFormControl(f.value));
    });
})

const emit = defineEmits(['close']);

const onConfirm = () => {
    const invalidFields: string[] = [];
    controls.forEach((x, index) => {
        if (!x.isValid) {
            x.markAsTouched()
            invalidFields.push(props.fields[index].label);
        }
    });
    if (invalidFields.length) {
        const list = invalidFields.map(name => `<li>${name}</li>`).join('');
        Toast.warning(`Há campos inválidos:<ul style="margin: 5px 0 0; padding-left: 18px;">${list}</ul>`);
        return;
    }
    let value: any = [];
    controls.forEach((x) => {
        value.push(x.value)
    });
    if (value.length == 1) {
        value = value[0];
    }
    emit('close', value);
}

</script>

<template>
    <form @submit="onConfirm">
        <div v-for="(field, index) in fields" :class="{'e-disabled': disabled}" :key="index">
            <GInputDynamic :control="controls[index]" :field="field"></GInputDynamic>
        </div>

        <div class="buttons">
            <GButton text="Cancelar" :block="true" @click="emit('close', false);"></GButton>
            <GButton v-if="!disabled" type="primary" text="Confirmar" :block="true" action-type="submit"
                @click="onConfirm"></GButton>
        </div>
    </form>

</template>

<style lang="scss" scoped>
form {
    display: grid;
    gap: 10px;
}

.buttons {
    display: grid;
    justify-content: flex-end;
    grid-template-columns: max-content max-content;
    gap: 10px;
    margin-top: 14px;
}
</style>